import { contextProvider } from '@wix/wix-chatbot-common/browser';
import type { HomepageContent } from '@wix/wix-help-widget-common/homepage';
import { CareProfile, UserExperience } from '@wix/wix-help-widget-common/personalization';

import { HttpClientFactory } from '../../common/httpClient';
import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';

const { wixBrand } = renderModel.get();
const { origin = '' } = renderModel.getQueryParams();

// TODO: can be delete when specs.helpwidget.newWidgetExperience is merged
export const getHomepageContentPersonalizationApi = async (
  httpClient: HttpClientFactory,
): Promise<HomepageContent> => {
  try {
    fedopsLogger.interactionStarted('fetching-homepage-content');
    const response = await httpClient
      .getInstance()
      .post<{ homepage: HomepageContent }>('/api/widget/personalization', {
        brand: wixBrand,
        origin,
        context: contextProvider.getMinimalContext(),
      });

    fedopsLogger.interactionEnded('fetching-homepage-content');

    return response.data.homepage;
  } catch (error) {
    logger.log({
      message: 'Failed to fetch Homepage Content',
      error,
    });
    console.error(error);
    throw error;
  }
};

export const getHomepageContent = async (
  httpClient: HttpClientFactory,
  userExperience?: UserExperience,
  careProfile?: CareProfile,
): Promise<HomepageContent> => {
  try {
    const response = await httpClient.getInstance().post<HomepageContent>('/api/widget/homepage', {
      brand: wixBrand,
      userExperience,
      careProfile,
    });

    return response.data;
  } catch (error) {
    logger.log({
      message: 'Failed to fetch Homepage Content',
      error,
    });
    console.error(error);
    throw error;
  }
};
